export enum EvaluationTimes {
    OnLoad,
    OnChange,
    OnSubmit
}